import { useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import { MdKeyboardArrowDown } from "react-icons/md";

function FilterBy({ filterBy = [], onFilter, selectedFilterKeys }) {
  const { t } = useTranslation("common");
  const [active, setActive] = useState(() =>
    Array.from({ length: filterBy.length }, (_, i) => i === 0)
  );

  useEffect(() => {
    setActive((prev) => {
      const next = Array.from({ length: filterBy.length }, () => false);

      for (let i = 0; i < Math.min(prev.length, next.length); i++) {
        next[i] = prev[i];
      }
      return next;
    });
  }, [filterBy.length]);

  const toggle = (idx) =>
    setActive((prev) => {
      const next = [...prev];
      next[idx] = !prev[idx];
      return next;
    });

  return (
    <ul>
      {filterBy
        ?.filter((e) => e?.list?.length)
        ?.map((itemParent, keyParent) => (
          <li key={itemParent?.attribute ?? keyParent} className="p-2 border-t first:border-t-0">
            <div
              onClick={() => toggle(keyParent)}
              className="flex items-center justify-between cursor-pointer select-none text-zinc-500"
            >
              <span className="font-semibold">{t(itemParent?.title)}</span>
              <MdKeyboardArrowDown
                size="19px"
                className={active[keyParent] ? "rotate-180" : "rotate-0"}
              />
            </div>

            {active[keyParent] && (
              <div className="p-2">
                 {itemParent?.list?.map((itemChild, keyChild) => {
                  const key = `${itemParent?.attribute}:${itemChild?.code}`;
                  const checked = !!selectedFilterKeys?.find((fv) => fv === key);

                  return (
                    <div
                      key={key ?? keyChild}
                      className="flex items-center justify-between mb-1 cursor-pointer last:mb-0"
                      onClick={() => onFilter(itemChild, itemParent)}
                    >
                      <label className="cursor-pointer" htmlFor={key}>
                        {itemChild?.label} ({itemChild?.count})
                      </label>
                      <input
                        id={key}
                        name={itemChild?.label}
                        type="checkbox"
                        checked={checked}
                        readOnly
                      />
                    </div>
                  );
                })}
              </div>
            )}
          </li>
        ))}
    </ul>
  );
}

export default FilterBy;
